import { EUsersRole } from '@common/enums/users-role.enum';
import { BitfStrapiModel } from '@common/libs/bitforce/core/models';

export class Role extends BitfStrapiModel {
  id: number;
  documentId: string;
  name: string;
  description: string;
  type: EUsersRole;
  publishedAt: string;

  constructor(data: Partial<Role> = {}) {
    super({ data });
  }

  get serialised() {
    return {
      id: this.id,
      name: this.name,
      description: this.description,
      type: this.type,
      documentId: this.documentId,
      publishedAt: this.publishedAt,
    };
  }
}
